import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import account from '@/services/auth/account';
import createApiError from '@/utils/api/createError';
const PREFIX = 'services: api: teams:';
const API_DOMAIN = process.env.NEXT_PUBLIC_FIREBASE_FUNCTIONS_DOMAIN;
const generateCreateUploadError = createApiError(`${PREFIX} createUpload:`);
const generateGetApiKeysError = createApiError(`${PREFIX} getApiKeys:`);
const generatePostApiKeyError = createApiError(`${PREFIX} postApiKeys:`);
const generateDeleteApiKeyError = createApiError(`${PREFIX} deleteApiKeys:`); // POST file upload

const createUploadRequest = (authToken, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return fetch(`${API_DOMAIN}/api/v0/teams/uploads`, {
    method: 'POST',
    headers: {
      Authorization: `FB-JWT ${authToken}`
    },
    body: formData
  });
}; // GET all a team's API Keys


const getApiKeysRequest = (teamId, authToken) => {
  return fetch(`${API_DOMAIN}/api/v0/teams/${teamId}/api-keys`, {
    method: 'GET',
    headers: {
      Authorization: `FB-JWT ${authToken}`
    }
  });
}; // POST to teams api key endpoint


const postApiKey = (teamId, authToken) => {
  return fetch(`${API_DOMAIN}/api/v0/teams/${teamId}/api-keys`, {
    method: 'POST',
    headers: {
      Authorization: `FB-JWT ${authToken}`
    }
  });
}; // DELETE api key from team


const deleteApiKeyRequest = (teamId, apiKeyId, authToken) => {
  return fetch(`${API_DOMAIN}/api/v0/teams/${teamId}/api-keys/${apiKeyId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `FB-JWT ${authToken}`
    }
  });
}; // Upload a file to the team's
// storage directory


const createUpload = async file => {
  let authToken = '';

  try {
    authToken = await account.getIdToken();
  } catch (err) {
    throw Error(`${PREFIX} createUpload: auth token could not be recovered: ${err}`);
  }

  let response;

  try {
    response = await createUploadRequest(authToken, file);
  } catch (err) {
    throw Error(`${PREFIX} createUpload: POST request failed: ${err}`);
  }

  let responseJson = {};

  if (response.status !== 204) {
    try {
      responseJson = await response.json();
    } catch (err) {
      throw Error(`${PREFIX} createUpload: failed to parse JSON: ${err}`);
    }
  } // Throw unsuccessful request API error


  const apiError = generateCreateUploadError(response.status, responseJson.errors);

  if (apiError) {
    throw apiError;
  }

  const isExpected = Array.isArray(responseJson.data) && responseJson.data.length && responseJson.data[0].attributes && responseJson.data[0].attributes.downloadUrl;

  if (!isExpected) {
    throw Error(`${PREFIX} createUpload: unexpected response payload`);
  } // Return first file's download URL


  return responseJson.data[0].attributes.downloadUrl;
}; // Download all API Keys
// associated with a team


const getApiKeys = async teamId => {
  let authToken = '';

  try {
    authToken = await account.getIdToken();
  } catch (err) {
    throw Error(`${PREFIX} getApiKeys: auth token could not be recovered: ${err}`);
  }

  let response;

  try {
    response = await getApiKeysRequest(teamId, authToken);
  } catch (err) {
    throw Error(`${PREFIX} getApiKeys: GET request failed: ${err}`);
  }

  let responseJson = {};

  try {
    responseJson = await response.json();
  } catch (err) {
    throw Error(`${PREFIX} getApiKeys: failed to parse JSON: ${err}`);
  } // Throw unsuccessful request API error


  const apiError = generateGetApiKeysError(response.status, responseJson.errors);

  if (apiError) {
    throw apiError;
  } // Return resolve the JSON-API
  // documents as API Keys


  return responseJson.data.map(_ref => {
    let {
      id,
      attributes
    } = _ref;
    return _objectSpread(_objectSpread({}, attributes), {}, {
      id
    });
  });
}; // Create a new API Key for team


const createApiKey = async teamId => {
  let authToken = '';

  try {
    authToken = await account.getIdToken();
  } catch (err) {
    throw Error(`${PREFIX} createApiKey: auth token could not be recovered: ${err}`);
  }

  let response;

  try {
    response = await postApiKey(teamId, authToken);
  } catch (err) {
    throw Error(`${PREFIX} createApiKey: POST request failed: ${err}`);
  }

  let responseJson = {};

  try {
    responseJson = await response.json();
  } catch (err) {
    throw Error(`${PREFIX} createApiKey: failed to parse JSON: ${err}`);
  } // Throw unsuccessful request API error


  const apiError = generatePostApiKeyError(response.status, responseJson.errors);

  if (apiError) {
    throw apiError;
  } // Return resolve the JSON-API
  // documents as API Keys


  return _objectSpread(_objectSpread({}, responseJson.data.attributes), {}, {
    id: responseJson.data.id
  });
}; // Remove an API Key from a team


const deleteApiKey = async (teamId, apiKeyId) => {
  var _responseJson;

  let authToken = '';

  try {
    authToken = await account.getIdToken();
  } catch (err) {
    throw Error(`${PREFIX} deleteApiKey: auth token could not be recovered: ${err}`);
  }

  let response;

  try {
    response = await deleteApiKeyRequest(teamId, apiKeyId, authToken);
  } catch (err) {
    throw Error(`${PREFIX} deleteApiKey: POST request failed: ${err}`);
  }

  let responseJson = {};

  if (response.status !== 204) {
    try {
      responseJson = await response.json();
    } catch (err) {
      throw Error(`${PREFIX} deleteApiKey: failed to parse JSON: ${err}`);
    }
  } // Throw unsuccessful request API error


  const apiError = generateDeleteApiKeyError(response.status, ((_responseJson = responseJson) === null || _responseJson === void 0 ? void 0 : _responseJson.errors) || {});

  if (apiError) {
    throw apiError;
  }
};

export default {
  getApiKeys,
  createUpload,
  createApiKey,
  deleteApiKey
};